module.exports = __webpack_public_path__ + "img/0965_graphite.072820d5.jpg";